import $ from 'jquery';

$(document).ready(function () {
    $('.cl-months-slider2').slick({
        dots: false,
        arrows: true,
        infinite: false,
        initialSlide: 0,
        asNavFor: '.calendar-month-slider2',
    });

    $('.calendar-month-slider2').slick({
        dots: false,
        arrows: false,
        infinite: false,
        initialSlide: 0,
        asNavFor: '.cl-months-slider2',
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.cl-categorie li').on('click', function () {
        $('.cl-categorie li.active').removeClass('active');
        $(this).addClass('active');

        var post_type = $(this).attr('data-post-type');

        $('.calendar-month-wrapper').fadeOut(500);

        if (post_type == 'all') {

            setTimeout(function () {
                $(".calendar-month-slider2 .event").each(function () {
                    $(this).slideDown();
                });

                setTimeout(function () {
                    $('.calendar-month-wrapper').fadeIn(500);
                }, 500);

            }, 650);

        } else {
            setTimeout(function () {
                $(".calendar-month-slider2 .event").each(function () {
                    if ($(this).attr('data-posttype') !== post_type) {
                        $(this).slideUp();
                    } else {
                        $(this).slideDown();
                    }
                });
                setTimeout(function () {
                    $('.calendar-month-wrapper').fadeIn(500);
                }, 500);
            }, 650);
        }
    });
});
